var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui main container"},[_c('h2',[_vm._v("Finalizar pedido")]),_c('Stepper',{attrs:{"steps":_vm.steps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }